import { render, staticRenderFns } from "./RemoveAccountPage.vue?vue&type=template&id=4d69f30c&scoped=true&"
import script from "./RemoveAccountPage.vue?vue&type=script&lang=js&"
export * from "./RemoveAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAccountPage.vue?vue&type=style&index=0&id=4d69f30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69f30c",
  null
  
)

export default component.exports